import React, { useMemo, useState } from "react";
import { Icon, Popconfirm, Table } from "antd";
import style from "./index.module.scss";
import TableFooter from "../TableFooter";
import EditableRow from "./Components/EditableRow";
import EditableCell from "./Components/EditableCell";
import _ from "lodash-es";
import { filterData, RuleModelItem } from "../../../../../service/score";
import { isTrue } from "../../../../../service/service";
import RenderTitle from "./Components/RenderTitle";
import { ColumnProps } from "antd/lib/table/interface";
import { useAtomValue } from "jotai";
import { disabledAtom } from "../../store";
import { useParams } from "react-router-dom";
import lodash from "lodash-es";

interface Iprops {
    data: RuleModelItem[];
    handleData: (val: RuleModelItem[]) => void;
    type: BooleanValue; //类型：0平时成绩 1期末成绩
    percent: number; //成绩占比
    ruleCourseName: string;
}

export interface newColumnProps extends ColumnProps<RuleModelItem> {
    editable?: boolean;
}

const Index: React.FC<Iprops> = ({
    data: dataSource,
    handleData: setDataSource,
    type,
    percent,
    ruleCourseName
}) => {
    const { courseNo, courseSeq } = useParams<StringMap>();

    const disabled = useAtomValue(disabledAtom({ courseNo, courseSeq }));

    //总分
    const totalCount = _.reduce(
        dataSource,
        (num, memo) => num + memo.weight,
        0
    );

    const count = useMemo(() => {
        return dataSource.length + 1;
    }, [dataSource]);
    const [hoveredRow, setHoveredRow] = useState<React.Key | null>(null);

    const operationColumns: newColumnProps[] = [
        {
            dataIndex: "operation",
            width: 50,
            align: "center",
            render: (_: string, record: RuleModelItem) =>
                !isTrue(record.fixed) ? (
                    <>
                        <img
                            src={require("./image/img.png")}
                            alt=""
                            className={style.icon}
                        />
                        <Popconfirm
                            title="确定删除?"
                            disabled={disabled}
                            onConfirm={() =>
                                handleDelete(record.key, record.id)
                            }>
                            <Icon type="delete" className={style.deleteBtn} />
                        </Popconfirm>
                    </>
                ) : null
        },
        {
            title: <RenderTitle title="考核模块" />,
            dataIndex: "ruleName",
            width: 120,
            editable: true,
            align: "center"
        },
        {
            title: <RenderTitle title="权重%" />,
            dataIndex: "weight",
            width: 100,
            editable: true,
            align: "center"
        },
        {
            title: <RenderTitle title="成绩规则" />,
            dataIndex: "description",
            width: 280,
            editable: true,
            align: "left"
        },
        {
            title: "成绩细则",
            dataIndex: "formulaModeJson",
            align: "left",
            editable: true,
            width: 370
        },
        {
            title: "备注",
            dataIndex: "remark",
            align: "center",
            editable: true
        }
    ];

    //新增自定义考核项
    const handleAdd = () => {
        const newData: RuleModelItem = {
            key: count,
            id: null, //考核模块id
            ruleId: null,
            ruleName: "", //考核模块名称
            weight: 0, //权重
            description: "", //成绩规则说明
            formulaModeJson: "", //成绩细则json(由前端自定义，告诉后端就行)
            type: type, //类型：0平时成绩 1期末成绩
            fixed: "0", //是否固定: 0否1是
            delStatus: 0, //删除标识
            flag: "CustomCalculator", //自定义
            remark: ""
        };
        setDataSource([...dataSource, newData]);
    };

    //删除当前行
    const handleDelete = (key: React.Key, id: number | null) => {
        const newData = lodash.cloneDeep(dataSource);
        if (!id) {
            const index = newData.findIndex(item => item.key === key);
            newData.splice(index, 1);
            setDataSource(newData);
        } else {
            const Source = newData.map(item => {
                if (item.key !== key) {
                    return item;
                } else {
                    return { ...item, weight: 0, delStatus: 1 };
                }
            });
            setDataSource(Source);
        }
    };

    //保存
    const handleSave = async (row: RuleModelItem) => {
        // 在这里执行保存操作，比如向服务器发送请求保存数据
        const newData = [...dataSource];
        const index = newData.findIndex(item => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row
        });
        setDataSource(newData);
    };

    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell
        }
    };

    const columns: any[] = [...operationColumns].map(col => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record: newColumnProps) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave
            })
        };
    });

    //鼠标悬停，按钮显示与隐藏的切换
    const rowClassName = (record: any) => {
        if (record.key === hoveredRow) {
            return style["hovered-row"];
        }
        return "";
    };

    return (
        <div className={style.root}>
            <Table
                rowKey="key"
                components={components}
                dataSource={filterData(dataSource)}
                columns={columns}
                pagination={false}
                rowClassName={rowClassName}
                onRow={record => ({
                    onMouseEnter: () => setHoveredRow(record.key),
                    onMouseLeave: () => setHoveredRow(null)
                })}
            />
            <TableFooter
                count={totalCount}
                onAdd={handleAdd}
                percent={percent}
                ruleCourseName={ruleCourseName}
            />
        </div>
    );
};

export default Index;
